"use client";

import * as React from 'react';
var context = /*#__PURE__*/React.createContext({
  eventKey: ''
});
context.displayName = 'AccordionItemContext';
export default context;